import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ClosuresFilters } from '../../../commons/models/closures';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store/reducers';

@Component({
  selector: 'app-closures-filters',
  templateUrl: './closures-filters.component.html',
  styleUrls: ['./closures-filters.component.scss']
})
export class ClosuresFiltersComponent {
  @Output()
  onFilter: EventEmitter<ClosuresFilters> = new EventEmitter();

  private _defaultFilters: ClosuresFilters;
  filtersForm: FormGroup;

  constructor(private fb: FormBuilder, private store$: Store<AppState>) {
    this._createForm();

  }

  private _createForm() {
    let group = {
      closure_date: '',
      onlyCurrentTenant: [true]

    }

    this.filtersForm = this.fb.group(group);
  }

  applyFilters() {
    this.onFilter.emit(this._getFilters());
  }

  private _getFilters(): ClosuresFilters {
    let filters: ClosuresFilters = {}
    if (this.filtersForm) {
      const values = this.filtersForm.value;
      if (values.closure_date) {
        filters.closure_date = values.closure_date;
      }
     
      filters.onlyCurrentTenant = values.onlyCurrentTenant;
      
    }
    return filters;
  }


  resetFilters() {
    this.filtersForm.reset();
    this.filtersForm.patchValue({
      closure_date: '',
      onlyCurrentTenant: true

    });
    this._setDefaultValues();
    this.applyFilters();
  }

  get defaultFilters(): ClosuresFilters {
    return this._defaultFilters;
  }

  @Input()
  set defaultFilters(defaultFilters: ClosuresFilters) {
    this._defaultFilters = defaultFilters;
    this._setDefaultValues();
  }

  private _setDefaultValues() {
    if (this.defaultFilters) {
      if (this.filtersForm) {
        this.filtersForm.patchValue({
          closure_date: this.defaultFilters.closure_date,
          onlyCurrentTenant: this.defaultFilters.onlyCurrentTenant

        })
      }
    }
  }
}

